module.exports = __webpack_public_path__ + "img/vector_active.f7f09e0b.svg";